import Api from 'src/api/Base'

class GetDeptBuyers extends Api {
  requestUrl = `/api/Buyer`
}
export default GetDeptBuyers
